import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fileService from "./fileService";

interface FileState {
  loading: boolean;
  error: any | null;
  message: string | null;
}

const initialState: FileState = {
  loading: false,
  error: null,
  message: null,
};

export const openFile = createAsyncThunk(
  "file/openFile",
  async (url: string, { rejectWithValue }) => {
    try {
      const opened = await fileService.openFile(url); 
        return { success: opened };
    } catch (error: any) {
      return rejectWithValue(error.message || "Error al abrir archivo");
    }
  }
);

export const fileSize = createAsyncThunk(
  "file/fileSize",
  async (url: string, { rejectWithValue }) => {
    try {
      const size = await fileService.fileSize(url);
      return { size };
    } catch (error: any) {
      return rejectWithValue(error.message || "Error al obtener el tamaño del archivo");
    }
  }
);

export const filesSize = createAsyncThunk(
  "file/filesSize",
  async (urls: string[], { rejectWithValue }) => {
    try {
      const totalSize = await fileService.filesSize(urls);
      return { totalSize };
    } catch (error: any) {
      return rejectWithValue(error.message || "Error al obtener el tamaño de los archivos");
    }
  }
);

const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    clearFileError: (state) => {
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(openFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(openFile.fulfilled, (state) => {
        state.loading = false;
        state.message = "Archivo abierto correctamente";
      })
      .addCase(fileSize.fulfilled, (state, action) => {
        state.loading = false;
        state.message = `Tamaño del archivo: ${action.payload.size} bytes`;
      })
      .addCase(openFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fileSize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(filesSize.fulfilled, (state, action) => {
        state.loading = false;
        state.message = `Tamaño total de los archivos: ${action.payload.totalSize} bytes`;
      })
      .addCase(filesSize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearFileError } = fileSlice.actions;
export default fileSlice.reducer;